import { type UseQueryResult, useQuery } from 'react-query';
import { StatusDropdownAppServicesService } from '@wealthlane/api-services/wealthlane-award-service';

const useGetReleaseRecordTypes = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const releaseRecordTypes = useQuery(
    ['getReleaseRecordTypes'],
    async () => {
      return await handleRequest(
        StatusDropdownAppServicesService.getApiAwardApiAppStatusDropdownAppServicesRecordTypesForTransferAllocate()
      );
    },
    {
      select: (data) => {
        const options = data?.map((item) => {
          return {
            label: item.displayName ?? '',
            value: item.id ?? '',
          };
        });

        return options;
      },
    }
  );

  return releaseRecordTypes;
};

export default useGetReleaseRecordTypes;
